import xlsxExport from '../../shared/xlsxExport/xlsxExport';
import {
  periodColumnDefinition,
} from '../../shared/columnDefinitions';
import { SheetExportTypes } from '@common/xlsxExport/xlsxExport.constants';
import { exportTaxBookingEntitiesColumnDefinitions } from '../../shared/columnDefinitions/taxBookingEntities';
import { sortBySeverity } from '../../shared/sortBySeverity';

type TaxBookEntity = Record<string, unknown> & { severity: string };

export const downloadTaxBookEntitiesXlsxFile = ({
  periodName,
  entities,
  environmentSuffix,
  shouldDisplayZero,
  hideDecimals,
  negativeMinus,
}: {
  periodName: string,
  entities: TaxBookEntity[],
  environmentSuffix: string,
  shouldDisplayZero: boolean,
  hideDecimals: boolean,
  negativeMinus: boolean,
}) => {
  const taxBookEntitiesWithPeriodName = entities
    .map((taxBookEntity): TaxBookEntity & { periodName: string } => ({
      periodName,
      ...taxBookEntity,
    }))
    .sort(sortBySeverity);

  const sheetData = [{
    name: 'Tax Book Entities',
    type: SheetExportTypes.GRID,
    columnDefinitions: [
      periodColumnDefinition,
      ...exportTaxBookingEntitiesColumnDefinitions,
    ],
    data: taxBookEntitiesWithPeriodName,
    options: {
      shouldDisplayZero,
      hideDecimals,
      negativeMinus,
    },
  }];

  return xlsxExport({
    sheetData,
    metadata: {
      fileName: `TLS_Tax_Book_Entities_${periodName}${environmentSuffix}`,
      disableHeaderRendering: true,
    },
  });
};
